import { render } from "./FeComplete.vue?vue&type=template&id=674b9412"
import script from "./FeComplete.vue?vue&type=script&lang=js"
export * from "./FeComplete.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\btobia\\Documents\\ProyectosVSC\\marketvue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__